export const findLabelByValue = (array, value) => array?.find((e) => e?.value === value)?.label;
export const arrayDiff = (arr1, arr2) => {
  const unique1 = arr1.filter((o) => arr2.indexOf(o) === -1);
  const unique2 = arr2.filter((o) => arr1.indexOf(o) === -1);
  return unique1.concat(unique2);
};
